import React from "react"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Report from "./report"
import { notification } from "antd"
const Index = props => {
  const [api, contextHolder] = notification.useNotification()
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }
  const { t } = props
  return (
    <>
      {contextHolder}
      <Report openNotification={openNotification} translate={t} />
    </>
  )
}

export default withRouter(withTranslation()(Index))
